import React from 'react'
import ReactDOM from 'react-dom/client'
import reportWebVitals from './reportWebVitals'
import { I18nContextProvider } from './i18n'
import AppRoutes from './routes'
import { Provider } from 'react-redux'
import { store } from './redux/store'
import 'bootstrap/dist/css/bootstrap.min.css'
import './assets/sass/style.scss'
import './assets/sass/style.react.scss'
import './assets/sass/custom.scss'
import './index.scss'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <I18nContextProvider>
                <AppRoutes />
            </I18nContextProvider>
        </Provider>
    </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
